module.exports = __webpack_public_path__ + "img/joinourdiscordnoshadow.d792a9b3.png";